/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';


class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="69.86" height="95.58" viewBox="0 0 69.86 95.58" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  <path d="M77.43,30.75A33.68,33.68,0,0,0,43.75,64.43c0,26.81,33.68,59.4,33.68,59.4s33.68-32.59,33.68-59.4A33.68,33.68,0,0,0,77.43,30.75Z" transform="translate(-42.5 -29.5)" fill="none" stroke="#0e497b" strokeWidth="2.5px" strokeLinejoin="round"/><path d="M77.43,45.32A18.62,18.62,0,1,0,96.05,63.93,18.61,18.61,0,0,0,77.43,45.32Zm0,2.5A16.12,16.12,0,1,1,61.32,63.93,16.12,16.12,0,0,1,77.43,47.82Z" transform="translate(-42.5 -29.5)" fill="#ffb81c"/>
</svg>

    );
  }
}

Icon.displayName = 'MapPinIcon';

export default Icon;
